import { ExternalLink } from 'lucide-react'

export interface ManualSetupStep {
  /** Caller-translated instruction. */
  text: string
  /** The provider's own how-to page for this step. */
  href: string
}

interface ManualSetupStepsProps {
  heading: string
  /** Caller-translated label for every link, e.g. "วิธีทำ". */
  linkLabel: string
  steps: ManualSetupStep[]
  testId?: string
}

/**
 * Steps an operator does outside FlowRent (LINE Developers, Firebase, Apple),
 * listed as instructions with a link to the provider's how-to. Nothing is
 * stored: owner 2026-10-08, instructions instead of checkboxes.
 */
export function ManualSetupSteps({ heading, linkLabel, steps, testId }: ManualSetupStepsProps) {
  return (
    <div className="mt-4" data-testid={testId}>
      <p className="text-xs font-medium text-base-content/60 mb-2">{heading}</p>
      <ul className="list-disc pl-5 space-y-1.5 text-sm">
        {steps.map((step) => (
          <li key={step.href}>
            {step.text}{' '}
            <a
              href={step.href}
              target="_blank"
              rel="noopener noreferrer"
              className="link link-primary inline-flex items-center gap-1 whitespace-nowrap"
            >
              {linkLabel}
              <ExternalLink className="w-3 h-3" aria-hidden="true" />
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
